"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureExpCampaign = void 0;
const createApi_1 = require("../../../helpers/createApi");
const schemas_1 = require("./schemas");
const account_1 = require("../account");
const list = (caller) => async ({ accountId, ...payload }) => {
    const url = `/accounts/${accountId}/campaigns`;
    return caller(url).get(payload).then(schemas_1.FeatureExpCampaignWithPaginationSchema.parse);
};
const get = (caller) => async ({ account_id, campaign_id }) => {
    const url = `/accounts/${account_id}/campaigns/${campaign_id}`;
    return caller(url).get().then(schemas_1.FeatureExpCampaignSchema.parse);
};
const getAccountByCampaignId = (caller) => async ({ campaign_id }) => {
    const url = `/campaigns/${campaign_id}/account`;
    return caller(url).get().then(account_1.FeatureExpAccountPartialSchema.parse);
};
const post = (caller) => ({ account_id, name, description, account_environment, project, custom_id, type, is_bucketable, wizard_type }) => {
    const url = `/accounts/${account_id}/campaigns`;
    return caller(url).post({
        name,
        description,
        type,
        project_id: project.id,
        custom_id,
        is_bucketable,
        wizard_type,
        account_environment_id: account_environment.id,
    });
};
const patch = (caller) => ({ account_id, id, ...fieldsToUpdate }) => {
    const url = `/accounts/${account_id}/campaigns/${id}`;
    const payload = {
        ...fieldsToUpdate,
        description: fieldsToUpdate.description ?? '',
        custom_id: fieldsToUpdate.custom_id ?? '',
        project_id: fieldsToUpdate.project?.id,
    };
    const cleanedPayload = Object.fromEntries(Object.entries(payload).filter(([, value]) => value !== undefined));
    return caller(url).patch(cleanedPayload);
};
const patchStatus = (caller) => ({ account_id, id, status }) => {
    const url = `/accounts/${account_id}/campaigns/${id}/status`;
    const payload = {
        status,
    };
    return caller(url).patch(payload);
};
const duplicate = (caller) => ({ account_id, payload }) => {
    const url = `/accounts/${account_id}/account_environments/${payload.environment_id}/campaigns/${payload.campaign_id}/duplicate`;
    const customPayload = {
        destination_account: payload.destination_account,
        destination_account_environment: payload.destination_account_environment,
        destination_project: payload.destination_project,
        type: payload.type,
        name: payload.name,
        description: payload.description,
        ...((payload.source_variation && { source_variation: payload.source_variation }) || {}),
        preflight: false,
    };
    return caller(url).post(customPayload);
};
const remove = (caller) => async ({ account_id, campaign_id }) => {
    return caller(`/accounts/${account_id}/campaigns/${campaign_id}`).delete();
};
exports.featureExpCampaign = (0, createApi_1.createAPIFactory)({
    list,
    get,
    getAccountByCampaignId,
    post,
    patch,
    patchStatus,
    duplicate,
    delete: remove,
});
//# sourceMappingURL=api.js.map